import {
  PermissionCheckInput,
  usePermissionCheckQuery,
} from "@/src/graphql/generated";
import useGqlClient from "./useGqlClient";

export const usePermissionCheck = (input: PermissionCheckInput) => {
  const client = useGqlClient();
  const permissionCheckQuery = usePermissionCheckQuery(client, {
    input: input,
  });

  if (
    permissionCheckQuery.isLoading ||
    !permissionCheckQuery.data ||
    permissionCheckQuery.error
  ) {
    return false;
  }

  return permissionCheckQuery.data.permissionCheck.hasAccess;
};
